export default __webpack_public_path__ + "static/media/Beard_1_C2.d16a726f.svg";